import React from "react";
import dayjs from "dayjs";
import { SettingContext } from "./Context";
import ViewInvoiceStatement from "../pages/InvoiceStatement/ViewInvoiceStatement.js";
// import Cookies from "js-cookie";

const MyGlobalData = ({ children }) => {
  let globalData = {
    URL: window.location.hostname,
    // API_URL: document.getElementById("API_URL").value,
    // API_URL: "http://localhost:3003",
    API_URL: "https://backend.finance.invoicewale.com",
    variable: {
      DateTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    },
    CompanyName: window.location.hostname,
    Version: "0.5",
    currScreen: "",
    login: {
      path: React.lazy(() => import("../pages/Auth/Login/Login")),
    },
    register: {
      path: React.lazy(() => import("../pages/Auth/Register/Register")),
    },
    verifyotp: {
      path: React.lazy(() => import("../pages/Auth/VerifyOtp/VerifyOtp")),
    },
    forgetpassword: {
      path: React.lazy(() =>
        import("../pages/Auth/ForgotPassword/ForgotPassword")
      ),
    },
    module_privilege: "",
    user_data: "",
    data_array: [],
    pages: {
      components: {
        leftsidebar: React.lazy(() =>
          import("../components/Leftsidebar/Leftsidebar")
        ),
      },
      dashboard:React.lazy(() => import("../pages/Dashboard/Dashboard")),
      forgotpassword: React.lazy(() =>
        import("../pages/Auth/ForgotPassword/ForgotPassword")
      ),
      changepassword: React.lazy(() =>
        import("../pages/Auth/ChangePassword/ChangePassword")
      ),
      user: {
        // addusers: React.lazy(() => import("../pages/Users/AddUsers")),
        // allusers: React.lazy(() => import("../pages/Users/AllUsers")),
        // useranalyst: React.lazy(() => import("../pages/Users/UsersAnalyst")),
        adduser: React.lazy(() => import("../pages/Users/AddUser")),
        userdetails: React.lazy(() => import("../pages/Users/UserDetails")),
        edituser: React.lazy(() => import("../pages/Users/EditUser")),
        // viewuser: React.lazy(() => import("../pages/Users/ViewUser")),
      },
      dynamicfields: {
        bankname: React.lazy(() => import("../pages/DynamicFields/BankName")),
        accounttype: React.lazy(() => import("../pages/DynamicFields/AccountType")),
        producttype: React.lazy(() => import("../pages/DynamicFields/ProductType")),
        institutename: React.lazy(() => import("../pages/DynamicFields/InstituteName")),
        tenure: React.lazy(() => import("../pages/DynamicFields/Tenure")),
        industry: React.lazy(() => import("../pages/DynamicFields/Industry")),
        products: React.lazy(() => import("../pages/DynamicFields/Products")),
        ratingagency: React.lazy(() => import("../pages/DynamicFields/RatingAgency")),
        customemail: React.lazy(() => import("../pages/DynamicFields/CustomEmail")),
        customwhatsapp: React.lazy(() => import("../pages/DynamicFields/CustomWhatsapp")),
      },
      company: {
        addcompany: React.lazy(() => import("../pages/Company/AddCompany")),
        companydetails: React.lazy(() => import("../pages/Company/CompanyDetails")),
        editcompany: React.lazy(() => import("../pages/Company/EditCompany")),
        quickeditcompany: React.lazy(() => import("../pages/Company/QuickEditCompany")),
        viewcompany: React.lazy(() => import("../pages/Company/ViewCompany")),
      },
      sanction: {
        addsanctiondetails: React.lazy(() => import("../pages/Sanction/AddSanctionDetails")),
        sanctiondetails: React.lazy(() => import("../pages/Sanction/SanctionDetails")),
        editsanctiondetails: React.lazy(() => import("../pages/Sanction/EditSanctionDetails")),
        quickeditsanctiondetails: React.lazy(() => import("../pages/Sanction/QuickEditSanctionDetails")),
        viewsanctiondetails: React.lazy(() => import("../pages/Sanction/ViewSanctionDetails")),
      },
      vendor: {
        addvendor: React.lazy(() => import("../pages/Vendor/AddVendor")),
        vendordetails: React.lazy(() => import("../pages/Vendor/VendorDetails")),
        editvendor: React.lazy(() => import("../pages/Vendor/EditVendor")),
        viewvendor: React.lazy(() => import("../pages/Vendor/ViewVendor")),
        addlender: React.lazy(() => import("../pages/Vendor/AddLender")),
        editlender: React.lazy(() => import("../pages/Vendor/EditLender")),
        viewlender: React.lazy(() => import("../pages/Vendor/ViewLender")),
        lenderdetails: React.lazy(() => import("../pages/Vendor/LenderDetails")),
      },
      invoice: {
        addinvoice: React.lazy(() => import("../pages/Invoice/AddInvoice")),
        invoicedetails: React.lazy(() => import("../pages/Invoice/InvoiceDetails")),
        pendinginvoices: React.lazy(() => import("../pages/Invoice/PendingInvoices")),
        dashboardinvoices: React.lazy(() => import("../pages/Invoice/DashboardInvoices")),
        editinvoice: React.lazy(() => import("../pages/Invoice/EditInvoice")),
        quickeditinvoice: React.lazy(() => import("../pages/Invoice/QuickEditInvoice")),
        quickeditfileupload: React.lazy(() => import("../pages/Invoice/QuickEditFileUploadDetails.js")),
        viewinvoice: React.lazy(() => import("../pages/Invoice/ViewInvoice")),
        changeinvoicestatus: React.lazy(() => import("../pages/Invoice/ChangeInvoiceStatus")),
        invoicestatements: React.lazy(() => import("../pages/InvoiceStatement/InvoiceStatementsDetails.js")),
        addinvoicestatement: React.lazy(() => import("../pages/InvoiceStatement/AddInvoiceStatement")),
        editinvoicestatement: React.lazy(() => import("../pages/InvoiceStatement/EditInvoiceStatement")),
        viewinvoicestatement: React.lazy(() => import("../pages/InvoiceStatement/ViewInvoiceStatement")),
      },
      lcsanction: {
        addlcsanctiondetails: React.lazy(() => import("../pages/LCSanction/AddLCSanctionDetails")),
        lcsanctiondetails: React.lazy(() => import("../pages/LCSanction/LCSanctionDetails")),
        editlcsanctiondetails: React.lazy(() => import("../pages/LCSanction/EditLCSanctionDetails")),
        quickeditlcsanctiondetails: React.lazy(() => import("../pages/LCSanction/QuickEditLCSanctionDetails")),
        viewlcsanctiondetails: React.lazy(() => import("../pages/LCSanction/ViewLCSanctionDetails")),
      },
      lc: {
        addlcdetails: React.lazy(() => import("../pages/LC/AddLCDetails")),
        lcdetails: React.lazy(() => import("../pages/LC/LCDetails.js")),
        editlcdetails: React.lazy(() => import("../pages/LC/EditLCDetails")),
        viewlcdetails: React.lazy(() => import("../pages/LC/ViewLCDetails")),
        quickeditlcdetails: React.lazy(() => import("../pages/LC/QuickEditLCDetails")),
        editlcamendment: React.lazy(() => import("../pages/LC/EditLCAmendment")),
      },
      boe: {
        addboedetails: React.lazy(() => import("../pages/BOE/AddBOEDetails")),
        boedetails: React.lazy(() => import("../pages/BOE/BOEDetails.js")),
        dashboardboedetails: React.lazy(() => import("../pages/BOE/DashboardBOEDetails.js")),
        editboedetails: React.lazy(() => import("../pages/BOE/EditBOEDetails")),
        viewboedetails: React.lazy(() => import("../pages/BOE/ViewBOEDetails")),
        quickeditboedetails: React.lazy(() => import("../pages/BOE/QuickEditBOEDetails")),
      },
      wclsanction: {
        addwclsanction: React.lazy(() => import("../pages/WCLSanction/AddWCLSanction.js")),
        wclsanctiondetails: React.lazy(() => import("../pages/WCLSanction/WCLSanctionDetails.js")),
        editwclsanction: React.lazy(() => import("../pages/WCLSanction/EditWCLSanction")),
        viewwclsanction: React.lazy(() => import("../pages/WCLSanction/ViewWCLSanction")),
      },
      wcldisbursement: {
        addwcldisbursement: React.lazy(() => import("../pages/WCLDisbursement/AddWCLDisbursement")),
        wcldisbursementdetails: React.lazy(() => import("../pages/WCLDisbursement/WCLDisbursementDetails")),
        editwcldisbursement: React.lazy(() => import("../pages/WCLDisbursement/EditWCLDisbursement")),
        viewwcldisbursement: React.lazy(() => import("../pages/WCLDisbursement/ViewWCLDisbursement")),
      },
      client: {
        addclient: React.lazy(() => import("../pages/Client/AddClient")),
        clientdetails: React.lazy(() => import("../pages/Client/ClientDetails")),
        editclient: React.lazy(() => import("../pages/Client/EditClient")),
        viewclient: React.lazy(() => import("../pages/Client/ViewClient")),
      },
      clientcontact: {
        addclientcontact: React.lazy(() => import("../pages/ClientContact/AddClientContact")),
        clientcontact: React.lazy(() => import("../pages/ClientContact/ClientContact")),
        editclientcontact: React.lazy(() => import("../pages/ClientContact/EditClientContact")),
        viewclientcontact: React.lazy(() => import("../pages/ClientContact/ViewClientContact")),
      },
      clientmeeting: {
        addclientmeeting: React.lazy(() => import("../pages/ClientMeeting/AddClientMeeting")),
        clientmeeting: React.lazy(() => import("../pages/ClientMeeting/ClientMeeting")),
        editclientmeeting: React.lazy(() => import("../pages/ClientMeeting/EditClientMeeting")),
        viewclientmeeting: React.lazy(() => import("../pages/ClientMeeting/ViewClientMeeting")),
      },
      whatsapp: {
        customwhatsapp: React.lazy(() => import("../pages/Whatsapp/CustomWhatsapp")),
      },
      bank: {
        addbank: React.lazy(() => import("../pages/Bank/AddBank")),
        bankdetails: React.lazy(() => import("../pages/Bank/BankDetails")),
        editbank: React.lazy(() => import("../pages/Bank/EditBank")),
        viewbank: React.lazy(() => import("../pages/Bank/ViewBank")),
      },
      bankcontact: {
        addbankcontact: React.lazy(() => import("../pages/BankContact/AddBankContact")),
        bankcontact: React.lazy(() => import("../pages/BankContact/BankContact")),
        editbankcontact: React.lazy(() => import("../pages/BankContact/EditBankContact")),
        viewbankcontact: React.lazy(() => import("../pages/BankContact/ViewBankContact")),
      },
      bankmeeting: {
        addbankmeeting: React.lazy(() => import("../pages/BankMeeting/AddBankMeeting")),
        bankmeeting: React.lazy(() => import("../pages/BankMeeting/BankMeeting")),
        editbankmeeting: React.lazy(() => import("../pages/BankMeeting/EditBankMeeting")),
        viewbankmeeting: React.lazy(() => import("../pages/BankMeeting/ViewBankMeeting")),
      },
      notice: {
        addnotice: React.lazy(() => import("../pages/Notice/AddNotice")),
        noticedetails: React.lazy(() => import("../pages/Notice/NoticeDetails")),
        editnotice: React.lazy(() => import("../pages/Notice/EditNotice")),
        viewnotice: React.lazy(() => import("../pages/Notice/ViewNotice")),
      },
      other: {
        allnotifications: React.lazy(() => import("../pages/Other/AllNotifications/AllNotifications")),
        loader: React.lazy(() => import("../pages/Other/Loader")),
        profile: React.lazy(() => import("../pages/Other/Profile/Profile")),
      },
    },
  };

  return (
    <SettingContext.Provider value={{ globalData }}>
      {children}
    </SettingContext.Provider>
  );
};

export default MyGlobalData;
